<template>
    <app-modal ref="modal" name="manage-tag-modal" :submit-on-enter="false" :title="title"
        :is-submitting="isLoading" @before-open="beforeOpen" width="30%">
        <app-search-box :placeholder="$t('directory.filter')" v-model="searchText" class="mb-3">
        </app-search-box>
        <div @click="onClick(tag)" v-for="tag in tagsFilteredByText" :key="tag.id"
            :class="{ 'active': !!activeTag && tag.id == activeTag }" class="tag-item d-flex justify-content-between mb-3">
            <span>
                <i class="far fa-tag" :style='{ color: tag.hex_color }'></i>
                <span>{{ tag.name }}</span>
            </span>
            <!-- {{ $t('app.edit') }} -->
            <div>
                <span @click="onClickEdit(tag)"><i class="far fa-edit mr-3"></i></span>
                <!-- {{ $t('app.delete') }} -->
                <span @click="onClickDelete(tag)"><i class="fal fa-trash mr-3"></i></span>
            </div>
        </div>
    </app-modal>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import AppModal from '@/components/app-modal/';
import AppSearchBox from '@/components/app-search-box';


export default {
    name: 'ManageTagModal',
    components: {
        AppModal,
        AppSearchBox
    },
    computed: {
        ...mapState(['tags']),
        tagsFilteredByText() {
            return this.tags.filter(tag => tag.name.toLowerCase().includes(this.searchText.toLowerCase()))
        }
    },
    data() {
        return {
            searchText: ''
        }
    },
    props: {
        tags: Array,
        activeTag: {},
        readonly: {
            type: Boolean,
            default: false,
        },
        shareTag: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        ...mapActions(['deleteTag']),
        onClick(tag) {
            if (this.activeTag && (tag.id === this.activeTag.id)) {
                return;
            }
            this.$emit('on-click', tag);
        },
        onClickEdit(tag) {
            this.$modal.show('tag-modal', { model: tag });
        },
        onClickDelete(tag) {
            this.$modal.show('dialog', {
                title: this.$t('tag.deleteTag'),
                text: this.$t('tag.deleteTagConfirmMsg'),
                okText: this.$t('app.delete'),
                okClass: 'btn btn-danger btn-sm',
                onOk: () => {
                    this.deleteTag(tag.id).then(() => {
                        this.$router.push({ name: 'main.dashboard', query: this.$route.query }).catch(() => { });
                    });
                },
            });
        },
        beforeOpen(params) {
            this.title = this.$t('tag.manageTag');
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/manage-tag-modal.vue